import React from 'react';
import Form, { Actions, EmailAddressValidator, Radio, RequiredValidator, TextField } from '../../../Components/Form';
import { useGrants } from '../../../Data/Business';
import Modal from '../../../Components/Modal';

const AddUser = ({isOpen, setIsOpen, onChanged}) => {
    return <Modal title="Add user" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{onChanged}} />}
    </Modal>
}

const Inner = ({onChanged}) => {
    const {addUser} = useGrants();

    return <Form onSubmit={addUser} closeModalOnSubmit afterSubmit={onChanged}>
        <TextField name="email" label="Email" validators={[RequiredValidator, EmailAddressValidator]} />
        <Radio name="role"
            label="Role"
            layout="List"
            options={[
                {label: 'Manager', value: 'Manager'},
                {label: 'Worker', value: 'Worker'},
            ]}
            validators={[RequiredValidator]}
        />
        <Actions submit={{label: 'Add user'}} cancel />
    </Form>
}

export default AddUser;
